export const Config = {
	lengthLabel: 30,
};
